import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39e6a1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "材料成本", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "（对比采购材料来自报价方案设定的材料清单）", -1))
const _hoisted_3 = { class: "ub" }
const _hoisted_4 = { style: {"margin-left":"100px"} }
const _hoisted_5 = { class: "ub ub-pe fw" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("继续保存采购订单")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_table_action = _resolveComponent("hmd-table-action")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    width: "1100px"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showFooter)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible=false))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showFooter)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_hmd_table_action, { class: "pt0" }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, "报价方案材料总价：" + _toDisplayString(_ctx.$filters.formatMoney(_ctx.baojiaTotal)), 1),
            _createElementVNode("div", _hoisted_4, "已产生费用：" + _toDisplayString(_ctx.$filters.formatMoney(_ctx.caigouTotal)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        tableLayout: 'fixed',
        "row-key": "materialNo1",
        bordered: true,
        columns: _ctx.columns,
        "data-source": _ctx.lists,
        pagination: false,
        rowClassName: _ctx.rowClassFn
      }, {
        index: _withCtx(({ index }) => [
          _createElementVNode("span", null, _toDisplayString(index+1), 1)
        ]),
        totalPrice1: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(record.totalPrice1!=='-'?_ctx.$filters.formatMoney(record.totalPrice1):'-'), 1)
        ]),
        totalPrice2: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(record.totalPrice2!=='-'?_ctx.$filters.formatMoney(record.totalPrice2):'-'), 1)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "rowClassName"])
    ]),
    _: 1
  }, 8, ["visible"]))
}